// frontend/src/components/admin/modules/RaceManager.js
import { api } from '../../../services/api.js';
import { Notification } from '../../../components/Notification.js';
import moment from 'moment-timezone';

const VENEZUELA_TIMEZONE = 'America/Caracas';

// Función auxiliar para crear y mostrar el modal del PDF
const openPdfModal = (url) => {
    const existing = document.getElementById('pdf-modal-overlay');
    if (existing) existing.remove();

    const overlay = document.createElement('div');
    overlay.id = 'pdf-modal-overlay';
    overlay.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.85); z-index: 10000; display: flex; justify-content: center; align-items: center; backdrop-filter: blur(4px);';

    const content = document.createElement('div');
    content.style.cssText = 'background: #1e293b; width: 90%; max-width: 900px; height: 85vh; border-radius: 12px; display: flex; flex-direction: column; overflow: hidden; border: 1px solid #D4AF37; box-shadow: 0 15px 25px rgba(0,0,0,0.6);';

    const header = document.createElement('div');
    header.style.cssText = 'display: flex; justify-content: space-between; align-items: center; padding: 15px 20px; background: #0f172a; border-bottom: 1px solid #334155;';
    header.innerHTML = '<h3 style="margin: 0; color: #D4AF37; font-size: 1.2rem;"><i class="fas fa-file-pdf"></i> Visualizador de Gaceta</h3><button id="close-pdf-modal" style="background: none; border: none; color: #ef4444; font-size: 1.5rem; cursor: pointer; padding: 0; line-height: 1;">&times;</button>';

    const iframe = document.createElement('iframe');
    iframe.src = url;
    // El fondo blanco es necesario porque muchos PDFs tienen transparencias que se verían mal sobre el fondo oscuro
    iframe.style.cssText = 'flex-grow: 1; width: 100%; height: 100%; border: none; background: #fff;';

    content.appendChild(header);
    content.appendChild(iframe);
    overlay.appendChild(content);
    document.body.appendChild(overlay);

    overlay.querySelector('#close-pdf-modal').addEventListener('click', () => overlay.remove());
    overlay.addEventListener('click', (e) => { if(e.target === overlay) overlay.remove(); });
};

export async function renderTracksManagement(container, notificationContainer) {
    container.innerHTML = `
        <h4>Crear Nuevo Hipódromo</h4>
        <div class="form-grid">
            <div class="form-group">
                <label for="trackName">Nombre del Hipódromo</label>
                <input type="text" id="trackName" placeholder="Ej: La Rinconada">
            </div>
            <div class="form-group">
                <label for="trackLocation">Ubicación</label>
                <input type="text" id="trackLocation" placeholder="Ej: Caracas, Venezuela">
            </div>
        </div>
        <button class="btn btn-primary" id="addTrackBtn">Añadir Hipódromo</button>
        <hr class="my-6">
        <h4>Lista de Hipódromos</h4>
    `;
    const tracksTable = document.createElement('table');
    tracksTable.className = 'table';
    container.appendChild(tracksTable);

    const trackNameInput = container.querySelector('#trackName');
    const trackLocationInput = container.querySelector('#trackLocation');
    const addTrackBtn = container.querySelector('#addTrackBtn');

    const fetchTracks = async () => {
        try {
            const response = await api.get(`/tracks?admin_mode=true&_t=${Date.now()}`);
            const tracks = response.tracks || response;

            if (!Array.isArray(tracks)) {
                console.error("La respuesta de la API para hipódromos no es un arreglo:", response);
                Notification(notificationContainer, 'Error: La respuesta de la API para hipódromos no tiene el formato esperado.', 'error');
                tracksTable.innerHTML = '<tr><td colspan="4">Error al cargar los datos.</td></tr>';
                return;
            }

            tracksTable.innerHTML = `
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Nombre</th>
                        <th>Ubicación</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    ${tracks.map(track => `
                        <tr>
                            <td>${track.id}</td>
                            <td>${track.name}</td>
                            <td>${track.location}</td>
                            <td>
                                <button class="btn btn-danger btn-sm delete-track-btn" data-id="${track.id}">Eliminar</button>
                            </td>
                        </tr>
                    `).join('')}
                </tbody>
            `;
            tracksTable.querySelectorAll('.delete-track-btn').forEach(btn => {
                btn.addEventListener('click', async () => {
                    if (confirm('¿Estás seguro de que quieres eliminar este hipódromo?')) {
                        try {
                            await api.delete(`/tracks/${btn.dataset.id}`);
                            Notification(notificationContainer, 'Hipódromo eliminado.', 'success');
                            fetchTracks();
                        } catch (error) {
                            Notification(notificationContainer, error.message || 'Error al eliminar hipódromo.', 'error');
                        }
                    }
                });
            });
        } catch (error) {
            Notification(notificationContainer, error.message || 'Error al cargar hipódromos.', 'error');
        }
    };

    addTrackBtn.addEventListener('click', async () => {
        const name = trackNameInput.value.trim();
        const location = trackLocationInput.value.trim();
        if (!name || !location) {
            Notification(notificationContainer, 'Nombre y ubicación son requeridos.', 'error');
            return;
        }
        try {
            await api.post('/tracks', { name, location });
            Notification(notificationContainer, 'Hipódromo añadido exitosamente.', 'success');
            trackNameInput.value = '';
            trackLocationInput.value = '';
            fetchTracks();
        }
        catch (error) {
            Notification(notificationContainer, error.message || 'Error al añadir hipódromo.', 'error');
        }
    });
    fetchTracks();
}

export async function renderRacesManagement(container, notificationContainer) {
    container.innerHTML = `
        <h4>Crear Nueva Carrera / Remate</h4>
        <div class="form-grid">
            <div class="form-group">
                <label for="raceTrackId">Hipódromo:</label>
                <select id="raceTrackId"></select>
            </div>
            <div class="form-group">
                <label for="raceName">Nombre de la Carrera:</label>
                <input type="text" id="raceName" placeholder="Ej: Clásico Simón Bolívar">
            </div>
            <div class="form-group">
                <label for="raceNumber">Número de Carrera:</label>
                <input type="number" id="raceNumber" placeholder="Ej: 5" min="1">
            </div>
            <div class="form-group">
                <label for="raceStartTime">Fecha y Hora de Inicio:</label>
                <input type="datetime-local" id="raceStartTime">
            </div>
            <div class="form-group">
                <label for="raceDistance">Distancia:</label>
                <input type="text" id="raceDistance" placeholder="Ej: 1800m">
            </div>
            <div class="form-group">
                <label for="raceSurface">Superficie:</label>
                <input type="text" id="raceSurface" placeholder="Ej: Arena">
            </div>
            <div class="form-group">
                <label for="racePurse">Premio (Purse):</label>
                <input type="number" id="racePurse" placeholder="Ej: 50000" min="0" step="0.01">
            </div>
             <div class="form-group">
                <label for="raceCurrencyCode">Moneda (Código):</label>
                <input type="text" id="raceCurrencyCode" value="USD" placeholder="Ej: USD">
            </div>
             <div class="form-group">
                <label for="raceCurrencySymbol">Moneda (Símbolo):</label>
                <input type="text" id="raceCurrencySymbol" value="$" placeholder="Ej: $">
            </div>
            <div class="form-group">
                <label for="raceStatus">Estado:</label>
                <select id="raceStatus">
                    <option value="scheduled">Programada</option>
                    <option value="open">Abierta</option>
                    <option value="closed">Cerrada</option>
                    <option value="finished">Finalizada</option>
                    <option value="cancelled">Cancelada</option>
                </select>
            </div>
            
            <!-- ⭐ NUEVO: PANEL DE REMATE ANTICIPADO B2B / VIP -->
            <div class="form-group" style="grid-column: 1 / -1; background: rgba(212,175,55,0.05); padding: 15px; border-radius: 8px; border: 1px dashed #D4AF37;">
                <label style="color: #D4AF37; cursor: pointer; display: flex; align-items: center; gap: 10px; font-size: 1rem; font-weight: bold;">
                    <input type="checkbox" id="isCustomRaceCheckbox" style="width:20px; height:20px; cursor: pointer; accent-color: #D4AF37;"> 
                    🌟 Crear como Remate Anticipado (Exclusivo para Operadores)
                </label>
                <div id="customRaceFields" class="hidden" style="margin-top: 15px; display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 15px; border-top: 1px solid #334155; padding-top: 15px;">
                    <div class="form-group" style="grid-column: 1 / -1;">
                        <p style="color:#10b981; margin:0 0 10px 0; font-size:0.9rem;">
                            <i class="fas fa-info-circle"></i> <b>NOTA:</b> La "Fecha de Inicio" debe ser la fecha <b>REAL de la carrera</b> (Sábado/Domingo). El remate quedará visible desde <b>AHORA MISMO</b> en la App para los clientes de este operador.
                        </p>
                    </div>
                    <div class="form-group">
                        <label for="exclusiveAlly" style="color: #facc15;">Operador Exclusivo (Requerido):</label>
                        <select id="exclusiveAlly" class="remate-select">
                            <option value="">-- Selecciona el Operador --</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <button class="btn btn-primary" id="createRaceBtn">Crear Carrera</button>
        <hr class="my-6">
        
        <h4>Lista de Carreras</h4>
        <div class="form-grid" style="align-items: end; grid-template-columns: 1fr 1fr 1fr auto; background: #1e293b; padding: 15px; border-radius: 8px; border: 1px solid #334155; margin-bottom: 15px;">
            <div class="form-group" style="margin: 0;">
                <label for="trackFilter">Hipódromo:</label>
                <select id="trackFilter" class="remate-select"></select>
            </div>
            <div class="form-group" style="margin: 0;">
                <label for="startDateFilter">Desde la fecha:</label>
                <input type="date" id="startDateFilter" class="remate-input" style="margin: 0;">
            </div>
            <div class="form-group" style="margin: 0;">
                <label for="endDateFilter">Hasta la fecha:</label>
                <input type="date" id="endDateFilter" class="remate-input" style="margin: 0;">
            </div>
            <div class="form-group" style="margin: 0;">
                <button class="btn btn-primary" id="applyFiltersBtn" style="height: 42px; padding: 0 20px;"><i class="fas fa-search"></i> Filtrar</button>
            </div>
        </div>

        <table class="table">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Hipódromo</th>
                    <th>#</th>
                    <th>Nombre / Tipo</th>
                    <th>Inicio</th>
                    <th>Estado</th>
                    <th>Gaceta (PDF)</th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody id="racesTableBody"></tbody>
        </table>
    `;

    const raceTrackIdSelect = container.querySelector('#raceTrackId');
    const raceNumberInput = container.querySelector('#raceNumber');
    const raceNameInput = container.querySelector('#raceName');
    const raceStartTimeInput = container.querySelector('#raceStartTime');
    const raceStatusSelect = container.querySelector('#raceStatus');
    const raceDistanceInput = container.querySelector('#raceDistance');
    const raceSurfaceInput = container.querySelector('#raceSurface');
    const racePurseInput = container.querySelector('#racePurse');
    const raceCurrencyCodeInput = container.querySelector('#raceCurrencyCode');
    const raceCurrencySymbolInput = container.querySelector('#raceCurrencySymbol');
    
    // Nodos VIP/Anticipado
    const isCustomRaceCheckbox = container.querySelector('#isCustomRaceCheckbox');
    const customRaceFields = container.querySelector('#customRaceFields');
    const raceEndTimeInput = container.querySelector('#raceEndTime');
    const exclusiveAllySelect = container.querySelector('#exclusiveAlly');
    
    const createRaceBtn = container.querySelector('#createRaceBtn');
    const racesTableBody = container.querySelector('#racesTableBody');
    
    // Filtros
    const trackFilterSelect = container.querySelector('#trackFilter');
    const startDateFilter = container.querySelector('#startDateFilter');
    const endDateFilter = container.querySelector('#endDateFilter');
    const applyFiltersBtn = container.querySelector('#applyFiltersBtn');

    // Configurar fechas por defecto (Día actual)
    const today = moment().tz(VENEZUELA_TIMEZONE).format('YYYY-MM-DD');
    startDateFilter.value = today;
    endDateFilter.value = today;

    // Activar Menú de Anticipados
    isCustomRaceCheckbox.addEventListener('change', (e) => {
        if (e.target.checked) {
            customRaceFields.classList.remove('hidden');
        } else {
            customRaceFields.classList.add('hidden');
            raceEndTimeInput.value = '';
            exclusiveAllySelect.value = '';
        }
    });

    const loadInitialData = async () => {
        try {
            // Cargar Hipódromos
            const response = await api.get(`/tracks?admin_mode=true&_t=${Date.now()}`);
            const tracks = response.tracks || response;
            if (!Array.isArray(tracks)) throw new Error("Formato de respuesta de hipódromos inválido");
            
            raceTrackIdSelect.innerHTML = '<option value="">-- Seleccionar Hipódromo --</option>' +
                tracks.map(track => `<option value="${track.id}">${track.name}</option>`).join('');

            trackFilterSelect.innerHTML = '<option value="">-- Todos los Hipódromos --</option>' +
                tracks.map(track => `<option value="${track.id}">${track.name}</option>`).join('');

            // Cargar Operadores para las Salas VIP
            try {
                const operators = await api.get('/users?role=payout_agent');
                exclusiveAllySelect.innerHTML = '<option value="">-- Todos (Público General) --</option>' +
                    operators.map(op => `<option value="${op.username}">${op.username} (${op.full_name})</option>`).join('');
            } catch(e) { console.warn("No se pudieron cargar los operadores B2B"); }

        } catch (error) {
            Notification(notificationContainer, error.message || 'Error al cargar datos iniciales.', 'error');
        }
    };

    // Función principal para obtener y renderizar con filtros defensivos
    const fetchAndRenderRaces = async (trackId = null, startDate = null, endDate = null) => {
        racesTableBody.innerHTML = '<tr><td colspan="8" style="text-align: center;"><i class="fas fa-spinner fa-spin"></i> Cargando...</td></tr>';
        
        try {
            const params = {};
            if (trackId) params.track_id = trackId;
            if (startDate) params.start_date = startDate;
            if (endDate) params.end_date = endDate;
            
            let races = await api.get('/races', { params });

            // 🛡️ FILTRADO DEFENSIVO EN EL FRONTEND
            if (trackId) {
                races = races.filter(r => String(r.track_id) === String(trackId));
            }
            if (startDate) {
                const startObj = moment.tz(startDate, VENEZUELA_TIMEZONE).startOf('day');
                races = races.filter(r => moment.utc(r.start_time).tz(VENEZUELA_TIMEZONE).isSameOrAfter(startObj));
            }
            if (endDate) {
                const endObj = moment.tz(endDate, VENEZUELA_TIMEZONE).endOf('day');
                races = races.filter(r => moment.utc(r.start_time).tz(VENEZUELA_TIMEZONE).isSameOrBefore(endObj));
            }

            if (races.length === 0) {
                racesTableBody.innerHTML = '<tr><td colspan="8" style="text-align: center; color: #94a3b8;">No se encontraron carreras con los filtros aplicados.</td></tr>';
                return;
            }

            racesTableBody.innerHTML = races.map(race => {
                const localStartTime = moment.utc(race.start_time).tz(VENEZUELA_TIMEZONE).format('YYYY-MM-DDTHH:mm');
                
                const gacetaHtml = race.gaceta_url 
                    ? `<button type="button" class="view-pdf-btn" data-url="${race.gaceta_url}" style="background:none; border:none; padding:0; color: #3b82f6; text-decoration: underline; font-weight: bold; font-size: 0.85rem; display: block; margin-bottom: 5px; cursor: pointer;"><i class="fas fa-file-pdf"></i> Ver PDF Actual</button>` 
                    : `<span style="color: #64748b; font-size: 0.85rem; font-style: italic; display: block; margin-bottom: 5px;">Sin Gaceta</span>`;

                // ⭐ NUEVO: Etiqueta Visual para Remates Anticipados (VIP)
                const customBadge = race.is_custom 
                    ? `<div style="margin-top:4px;"><span style="background:#8b5cf6; color:white; padding:3px 6px; border-radius:4px; font-size:0.7rem; font-weight:bold;"><i class="fas fa-crown"></i> VIP: ${race.exclusive_for_ally || 'Público'}</span></div>` 
                    : '';

                return `
                <tr data-id="${race.id}">
                    <td>${race.id}</td>
                    <td>${race.track_name || 'N/A'}</td>
                    <td>${race.race_number}</td>
                    <td><b>${race.name}</b> ${customBadge}</td>
                    <td><input type="datetime-local" class="race-start-time-input" value="${localStartTime}"></td>
                    <td>${race.status}</td>
                    <td>
                        ${gacetaHtml}
                    </td>
                    <td>
                        <div style="display:flex; gap:5px;">
                            <button class="btn btn-success btn-sm save-race-btn" data-id="${race.id}" data-hp="${race.house_profit || 25}" data-pote="${race.manual_pote || 0}">Guardar</button>
                            <button class="btn btn-danger btn-sm delete-race-btn" data-id="${race.id}">Eliminar</button>
                        </div>
                    </td>
                </tr>
            `}).join('');

            racesTableBody.querySelectorAll('.view-pdf-btn').forEach(btn => {
                btn.addEventListener('click', () => openPdfModal(btn.dataset.url));
            });

            racesTableBody.querySelectorAll('.save-race-btn').forEach(btn => {
                btn.addEventListener('click', async () => {
                    const row = btn.closest('tr');
                    const raceId = row.dataset.id;
                    const newStartTimeLocal = row.querySelector('.race-start-time-input').value;

                    if (!newStartTimeLocal) {
                        Notification(notificationContainer, 'La fecha y hora de inicio son requeridas.', 'error');
                        return;
                    }
                    const raceStartTimeUTC = moment.tz(newStartTimeLocal, VENEZUELA_TIMEZONE).utc().toISOString();
                    try {
                        const originalHtml = btn.innerHTML;
                        btn.disabled = true;
                        btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';

                        await api.put(`/races/${raceId}`, { start_time: raceStartTimeUTC });
                        
                        Notification(notificationContainer, 'Hora de la carrera actualizada exitosamente.', 'success');
                        refreshCurrentRacesView(); 
                    } catch (error) {
                        Notification(notificationContainer, error.message || 'Error al actualizar la carrera.', 'error');
                        btn.disabled = false;
                        btn.innerHTML = 'Guardar';
                    }
                });
            });

            racesTableBody.querySelectorAll('.delete-race-btn').forEach(btn => {
                btn.addEventListener('click', async () => {
                    if (confirm('¿Estás seguro de que quieres eliminar esta carrera?')) {
                        try {
                            await api.delete(`/races/${btn.dataset.id}`);
                            Notification(notificationContainer, 'Carrera eliminada.', 'success');
                            refreshCurrentRacesView(); 
                        } catch (error) {
                            Notification(notificationContainer, error.message || 'Error al eliminar carrera.', 'error');
                        }
                    }
                });
            });
        } catch (error) {
            Notification(notificationContainer, error.message || 'Error al cargar carreras.', 'error');
        }
    };

    const refreshCurrentRacesView = () => {
        fetchAndRenderRaces(trackFilterSelect.value, startDateFilter.value, endDateFilter.value);
    };

    applyFiltersBtn.addEventListener('click', () => {
        refreshCurrentRacesView();
    });

    createRaceBtn.addEventListener('click', async () => {
        const localStartTime = raceStartTimeInput.value;
        const isCustom = isCustomRaceCheckbox.checked;

        if (!localStartTime) {
            Notification(notificationContainer, 'La fecha y hora de inicio son requeridas.', 'error');
            return;
        }

        if (isCustom && !exclusiveAllySelect.value) {
            Notification(notificationContainer, 'Debes seleccionar un Operador Exclusivo para el remate anticipado.', 'error');
            return;
        }
        
        const raceStartTimeUTC = moment.tz(localStartTime, VENEZUELA_TIMEZONE).utc().toISOString();

        const payload = {
            track_id: parseInt(raceTrackIdSelect.value),
            race_number: parseInt(raceNumberInput.value),
            name: raceNameInput.value.trim(),
            start_time: raceStartTimeUTC, 
            status: raceStatusSelect.value,
            distance: raceDistanceInput.value.trim(),
            surface: raceSurfaceInput.value.trim(),
            purse: parseFloat(racePurseInput.value),
            currency_code: raceCurrencyCodeInput.value.trim(),
            currency_symbol: raceCurrencySymbolInput.value.trim(),
            // ⭐ CAMPOS NUEVOS B2B (Mantenemos is_custom y eliminamos end_time)
            is_custom: isCustom,
            exclusive_for_ally: isCustom ? exclusiveAllySelect.value : null
        };

        if (!payload.track_id || !payload.name || !payload.start_time || isNaN(payload.race_number)) {
            Notification(notificationContainer, 'Hipódromo, Nombre, Número y Hora de inicio son requeridos.', 'error');
            return;
        }

        const btnOriginal = createRaceBtn.innerHTML;
        createRaceBtn.disabled = true;
        createRaceBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Creando...';

        try {
            await api.post('/races', payload);
            Notification(notificationContainer, 'Carrera creada exitosamente.', 'success');
            
            raceNameInput.value = '';
            raceNumberInput.value = '';
            if(isCustom) {
                isCustomRaceCheckbox.checked = false;
                customRaceFields.classList.add('hidden');
                exclusiveAllySelect.value = '';
            }
            refreshCurrentRacesView(); 
        } catch (error) {
            Notification(notificationContainer, error.message || 'Error al crear la carrera.', 'error');
        } finally {
            createRaceBtn.disabled = false;
            createRaceBtn.innerHTML = btnOriginal;
        }
    });

    await loadInitialData();
    refreshCurrentRacesView();
}

export async function renderHorsesJockeysManagement(container, notificationContainer) {
    container.innerHTML = `
        <h4>Gestionar Participantes de Carrera</h4>
        <div class="form-grid">
            <div class="form-group">
                <label for="trackFilterForHorses">Filtrar por Hipódromo:</label>
                <select id="trackFilterForHorses"></select>
            </div>
            <div class="form-group">
                <label for="selectRaceForHorses">Seleccionar Carrera:</label>
                <select id="selectRaceForHorses"></select>
            </div>
        </div>
        <div id="horseJockeyManagement" class="hidden mt-4 p-4 border rounded-lg" style="background:#1e293b; border-color:#334155;">
            <h5>Añadir Participante</h5>
            <div class="form-grid">
                <div class="form-group">
                    <label for="addHorseName">Nombre del Caballo:</label>
                    <input type="text" id="addHorseName" placeholder="Nombre del Caballo">
                </div>
                <div class="form-group">
                    <label for="addJockeyName">Nombre del Jinete:</label>
                    <input type="text" id="addJockeyName" placeholder="Nombre del Jinete">
                </div>
                 <div class="form-group">
                    <label for="addHorseNumber">Número del Caballo:</label>
                    <input type="number" id="addHorseNumber" min="1" placeholder="Ej: 5">
                </div>
            </div>
            <button class="btn btn-success" id="addHorseToRaceBtn"><i class="fas fa-plus"></i> Añadir Participante</button>
            
            <h5 class="mt-6 mb-3 border-b border-gray-600 pb-2">Participantes en esta Carrera:</h5>
            <ul id="currentRaceHorsesList" style="list-style:none; padding:0; margin:0;"></ul>
        </div>
    `;

    const trackFilterForHorses = container.querySelector('#trackFilterForHorses');
    const selectRaceForHorses = container.querySelector('#selectRaceForHorses');
    const horseJockeyManagementDiv = container.querySelector('#horseJockeyManagement');
    const addHorseNameInput = container.querySelector('#addHorseName');
    const addJockeyNameInput = container.querySelector('#addJockeyName');
    const addHorseNumberInput = container.querySelector('#addHorseNumber');
    const addHorseToRaceBtn = container.querySelector('#addHorseToRaceBtn');
    const currentRaceHorsesList = container.querySelector('#currentRaceHorsesList');
    
    let allRaces = [];

    const loadInitialData = async () => {
        try {
            const trackResponse = await api.get(`/tracks?_t=${Date.now()}`);
            const tracks = trackResponse.tracks || trackResponse;
            if (!Array.isArray(tracks)) throw new Error("Formato de respuesta de hipódromos inválido");
            
            trackFilterForHorses.innerHTML = '<option value="">-- Todos los Hipódromos --</option>' +
                tracks.map(track => `<option value="${track.id}">${track.name}</option>`).join('');

            // ⭐ FIX BUG 2: Filtramos estrictamente las carreras del DÍA DE HOY para limpiar el historial
            const startOfDayUTC = moment().tz(VENEZUELA_TIMEZONE).startOf('day').utc().toISOString();
            const endOfDayUTC = moment().tz(VENEZUELA_TIMEZONE).endOf('day').utc().toISOString();
            
            allRaces = await api.get(`/races?start_date=${startOfDayUTC}&end_date=${endOfDayUTC}`);
            populateRacesDropdown(allRaces);

        } catch (error) {
            Notification(notificationContainer, error.message || 'Error al cargar datos iniciales.', 'error');
        }
    };

    const populateRacesDropdown = (races) => {
        selectRaceForHorses.innerHTML = '<option value="">-- Seleccionar Carrera --</option>' +
            races.map(race => `<option value="${race.id}">Carrera #${race.race_number} - ${race.name} (${race.track_name})</option>`).join('');
    };

    trackFilterForHorses.addEventListener('change', () => {
        const selectedTrackId = trackFilterForHorses.value;
        const filteredRaces = selectedTrackId 
            ? allRaces.filter(race => race.track_id == selectedTrackId)
            : allRaces;
        populateRacesDropdown(filteredRaces);
        horseJockeyManagementDiv.classList.add('hidden');
    });

    const fetchAndRenderRaceHorses = async (raceId) => {
        if (!currentRaceHorsesList) {
            console.error("Error: El elemento con id 'currentRaceHorsesList' no se encontró en el DOM.");
            return;
        }
        currentRaceHorsesList.innerHTML = '<span class="text-gray-500">Cargando participantes...</span>';
        try {
            const horsesInRace = await api.get(`/races/${raceId}/horses`);
            
            currentRaceHorsesList.innerHTML = horsesInRace.map(h => {
                // ⭐ FIX BUG 1: Extracción Poka-Yoke del ID real del caballo
                const horseIdToUse = h.horse_id || h.id; 
                
                return `
                <li class="flex justify-between items-center p-3 rounded-lg shadow-sm mb-2" style="background-color: #1e293b; border: 1px solid #334155;">
                    <div style="display:flex; align-items:center; gap:15px;">
                        <div style="background:#334155; color:#D4AF37; font-weight:bold; font-size:1.2rem; width:40px; height:40px; display:flex; align-items:center; justify-content:center; border-radius:8px;">
                            #${h.horse_number}
                        </div>
                        <div>
                            <div style="font-weight:bold; color:#f8fafc; font-size:1.1rem;">${h.horse_name || h.name}</div>
                            <div style="color:#94a3b8; font-size:0.85rem;"><i class="fas fa-user-alt" style="margin-right:4px;"></i>${h.jockey_name || 'N/A'}</div>
                        </div>
                    </div>
                    <div style="display:flex; gap:8px;">
                        <button class="btn btn-warning btn-sm scratch-horse-btn" data-race-id="${raceId}" data-horse-id="${horseIdToUse}">
                            🚫 Retirar y Devolver Dinero
                        </button>
                        <button class="btn btn-danger btn-sm remove-horse-btn" data-race-id="${raceId}" data-horse-id="${horseIdToUse}">
                            🗑️ Eliminar
                        </button>
                    </div>
                </li>
            `}).join('') || '<li class="text-gray-500 italic">No hay participantes en esta carrera.</li>';

            currentRaceHorsesList.querySelectorAll('.remove-horse-btn').forEach(btn => {
                btn.addEventListener('click', async () => {
                    // ⭐ FIX BUG 1: Candado anti-NaN (Datos corruptos o nulos)
                    const rId = parseInt(btn.dataset.raceId);
                    const hId = parseInt(btn.dataset.horseId);
                    
                    if (isNaN(rId) || isNaN(hId)) {
                        return Notification(notificationContainer, 'Error de sistema: ID de caballo o carrera inválido.', 'error');
                    }

                    if (confirm('¿Seguro que quieres eliminar este participante de la lista? (Esta acción no devuelve dinero, solo lo quita del registro)')) {
                        try {
                            await api.post('/races/remove-horse-entry', {
                                raceId: rId,
                                horseId: hId
                            });
                            Notification(notificationContainer, 'Participante eliminado de la lista.', 'success');
                            fetchAndRenderRaceHorses(rId);
                        } catch (error) {
                            Notification(notificationContainer, error.message || 'Error al eliminar.', 'error');
                        }
                    }
                });
            });

            currentRaceHorsesList.querySelectorAll('.scratch-horse-btn').forEach(btn => {
                btn.addEventListener('click', async () => {
                    // ⭐ FIX BUG 1: Candado anti-NaN (Datos corruptos o nulos)
                    const rId = parseInt(btn.dataset.raceId);
                    const hId = parseInt(btn.dataset.horseId);
                    
                    if (isNaN(rId) || isNaN(hId)) {
                        return Notification(notificationContainer, 'Error de sistema: ID de caballo o carrera inválido.', 'error');
                    }

                    const confirmMsg = "⚠️ ATENCIÓN: Al Retirar este caballo, el sistema DEVOLVERÁ AUTOMÁTICAMENTE todo el dinero apostado por él (Remate y Win/Place) a las billeteras de los usuarios.\n\n¿Estás totalmente seguro de procesar el retiro?";
                    if (confirm(confirmMsg)) {
                        const originalHtml = btn.innerHTML;
                        btn.innerHTML = '⏳ Procesando...';
                        btn.disabled = true;

                        try {
                            await api.post('/remate/refund-horse', {
                                raceId: rId,
                                horseId: hId
                            });
                            Notification(notificationContainer, 'Ejemplar retirado y dinero devuelto a los usuarios correctamente.', 'success');
                            fetchAndRenderRaceHorses(rId);
                        } catch (error) {
                            Notification(notificationContainer, error.message || 'Error al procesar el retiro del caballo.', 'error');
                            btn.innerHTML = originalHtml;
                            btn.disabled = false;
                        }
                    }
                });
            });

        } catch (error) {
            Notification(notificationContainer, error.message || 'Error al cargar participantes.', 'error');
            currentRaceHorsesList.innerHTML = '<li class="text-red-500">Error al cargar la lista.</li>';
        }
    };

    selectRaceForHorses.addEventListener('change', (e) => {
        const raceId = e.target.value;
        if (raceId) {
            horseJockeyManagementDiv.classList.remove('hidden');
            fetchAndRenderRaceHorses(raceId);
        } else {
            horseJockeyManagementDiv.classList.add('hidden');
        }
    });

    addHorseToRaceBtn.addEventListener('click', async () => {
        const raceId = parseInt(selectRaceForHorses.value);
        const horseName = addHorseNameInput.value.trim();
        const jockeyName = addJockeyNameInput.value.trim();
        const horseNumber = parseInt(addHorseNumberInput.value);

        if (!raceId || !horseName || !jockeyName || isNaN(horseNumber)) {
            Notification(notificationContainer, 'Todos los campos son requeridos.', 'error');
            return;
        }

        try {
            await api.post('/races/add-horse-entry', { raceId, horseName, jockeyName, horseNumber });
            Notification(notificationContainer, 'Participante añadido.', 'success');
            addHorseNameInput.value = '';
            addJockeyNameInput.value = '';
            addHorseNumberInput.value = '';
            fetchAndRenderRaceHorses(raceId);
        } catch (error) {
            Notification(notificationContainer, error.message || 'Error al añadir participante.', 'error');
        }
    });

    await loadInitialData();
}